import { Button as DesignSystemButton } from 'design-system';
import styled, { css } from 'styled-components';

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 1rem;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & p {
    margin: 0;
    margin-bottom: 1rem;
    font-size: 1.25rem;
    text-align: center;

    @media (max-width: 600px) {
      font-size: 1rem;
    }

    &:first-child {
      margin: 1rem 0;
    }

    &:last-child {
      margin-bottom: 2.5rem;
    }
  }
`;

export const FormContainer = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  max-width: 25rem;

  width: 100%;
`;

export const ValidatorsContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: start;
  width: 100%;
  

  @media (max-width: 600px) {
    padding-bottom: 2rem;
  }

  & ul {
    padding: 0 0 0 1rem;
    margin: 0;
    gap: 0.25rem;
    display: flex;
    flex-direction: column;
    color: #f44336;
  }
`;

export const Button = styled(DesignSystemButton)<{ $limitWidth?: boolean }>`
  ${({ $limitWidth }) =>
    $limitWidth &&
    css`
      max-width: 21.875rem;
      width: 100%;
    `}
`;

export const DocsLink = styled.a`
  padding: 0 0.3rem;
`;
